var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 76,
    viewBox: "0 0 83 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11948 67.6923C3.47972 70.0621 5.45065 72.0291 7.83072 73.3928C10.2101 74.7558 12.9132 75.4658 15.6608 75.4497L67.3588 75.4491C72.9452 75.4491 78.1069 72.4919 80.9001 67.6923C83.6933 62.8921 83.6933 56.9784 80.9001 52.1782L55.0519 7.75675C52.2587 2.95718 47.097 0 41.5106 0C35.9242 0 30.7625 2.95653 27.9693 7.75675L2.11948 52.1782C0.731564 54.5313 0 57.2089 0 59.9356C0 62.6623 0.731597 65.3397 2.11948 67.6923V67.6923ZM37.622 16.387C37.6227 16.0231 37.9199 15.7276 38.2867 15.7276H44.7321C45.0995 15.7276 45.3968 16.0231 45.3968 16.387V47.3954C45.3968 47.76 45.0995 48.0549 44.7321 48.0549H38.2867C37.9199 48.0549 37.6227 47.7593 37.622 47.3954V16.387ZM37.622 58.0366C37.6227 57.6727 37.9199 57.3778 38.2867 57.3778H44.7321C45.0995 57.3778 45.3968 57.6727 45.3968 58.0366V64.4316C45.3968 64.7962 45.0995 65.0911 44.7321 65.0911H38.2867C37.9199 65.0911 37.6227 64.7962 37.622 64.4316V58.0366Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e0ac1a1a76b1e64558a80d94f838e03a.svg";
export { ForwardRef as ReactComponent };